import { Box, Button, Typography, styled } from "@mui/material";

export const SpaceBetweenBox = styled(Box)(
  ({ theme, marginBottom, alignItems }) => ({
    display: "flex",
    alignItems: alignItems || "flex-start",
    justifyContent: "space-between",
    marginBottom: theme.spacing(marginBottom || 1),

    "&:last-child": {
      marginBottom: 0,
    },

    "> *": {
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
    },
  })
);

export const AdornmentButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(0),
  minWidth: "40px",
  minHeight: "40px !important",
}));

export const LongText = styled(Typography)(() => ({
  wordBreak: "break-all",
}));
